
import React from 'react'
import Navigations from './navigations';
 
function header() {
  return (
    <header>
      <Navigations/>
    </header>
  )
}

export default header
